import { TimeBonusReasonModel } from "./timeBonusReason.model";

export class ExcusedAbsenceQualificationContextModel {
  timeOccurrenceId: string | undefined = undefined;
  selectedBonusReasonId: string | undefined = undefined;
  allowedBonusReasons: TimeBonusReasonModel[] = [];

  static create(input: any): ExcusedAbsenceQualificationContextModel {
    const model = new ExcusedAbsenceQualificationContextModel();
    model.timeOccurrenceId = input?.timeOccurrenceId;
    model.selectedBonusReasonId = input?.selectedBonusReasonId;
    model.allowedBonusReasons = (input?.allowedBonusReasons ?? []).map((item: any) =>
      TimeBonusReasonModel.create(item)
    );
    return model;
  }
}
